import { PTP_CONTACT_US_LINK } from "utils/constants";

import * as S from "./styled";
import { StyledLink } from "./styled";

export const ContactUs = () => {
  return (
    <>
      <S.Box className="flex w-full justify-center">
        <S.Description>Have questions or trouble signing up?</S.Description>
      </S.Box>

      <div className="flex w-full justify-center">
        <StyledLink className="primary" href={PTP_CONTACT_US_LINK} rel="noreferrer" target="_blank">
          Contact us
        </StyledLink>
      </div>
    </>
  );
};